module.exports = __webpack_public_path__ + "static/img/slide-4.b6354fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/benefits/slide-4.png
// module id = 4t1g
// module chunks = 1